<div class="page-header col-md-12 p-3">
    <div class="row">
        <div class="col-md-4">
            <h3 class="page-title" translate>Appointment Details</h3>
            <ol class="breadcrumb bg-white p-0">

                <li class="breadcrumb-item active " aria-current="page">Details</li>
            </ol>
        </div>
        <!-- Button Group for Large Screens -->
        <div class="col-md-8 d-none d-md-flex justify-content-md-end align-items-center">




            <button class="btn  mx-1 border border-white rounded   " (click)='backClicked()' translate><i
                    class="fa fa-arrow-left"></i>BACK</button>

            <button class="btn mx-1 border border-white rounded   " (click)="openClientDetails(userappointment[0])"
                *ngIf="isSystemAdmin() || isAdmin() || isReceptionist()" translate><i class="fa fa-user px-1"></i>VIEW
                CLIENT</button>

            <button class="btn mx-1 border border-white rounded   " (click)='sendEmail(userappointment[0])'
                *ngIf="isSystemAdmin() || isAdmin() || isReceptionist()" translate><i
                    class="fa fa-paper-plane px-1"></i>SEND EMAIL</button>

            <button class="btn mx-1 border border-white rounded " (click)='editAppointment(userappointment[0])'
                *ngIf="isSystemAdmin() || isAdmin() || isReceptionist()" translate><i
                    class="fa fa-edit"></i>EDIT</button>



        </div>



        <!-- Dropdown Menu for Small Screens -->
        <div class="col-12 d-flex d-md-none justify-content-end ">
            <div ngbDropdown class="d-flex d-md-none justify-content-end mt-2">
                <button class="btn btn-light border no-arrow" ngbDropdownToggle>
                    <i class="fa fa-ellipsis-h"></i>
                </button>
                <div ngbDropdownMenu class="dropdown-menu-right">
                    <a class="dropdown-item border-bottom p-2" href="#" (click)='backClicked()' translate><i
                            class="fa fa-arrow-left"></i>BACK</a>
                    <a class="dropdown-item border-bottom p-2" href="#" (click)="openClientDetails(userappointment[0])"
                        *ngIf="isSystemAdmin() || isAdmin() || isReceptionist()" translate><i
                            class="fa fa-user px-1"></i>VIEW CLIENT</a>
                    <a class="dropdown-item border-bottom p-2" href="#" (click)='sendEmail(userappointment[0])'
                        *ngIf="isSystemAdmin() || isAdmin() || isReceptionist()" translate><i
                            class="fa fa-paper-plane px-1"></i>SEND EMAIL</a>
                    <a class="dropdown-item border-bottom p-2" (click)='editAppointment(userappointment[0])'
                        *ngIf="isSystemAdmin() || isAdmin() || isReceptionist()" translate><i
                            class="fa fa-edit"></i>EDIT</a>

                </div>
            </div>
        </div>
    </div>

</div>



<section class="container-fluid mt-2 p-0 w-100 ">
    <div class="row w-100 m-0 ">

        <div class="col-xs-11 w-100">

            <div class="box box-danger  border-top  shadow-lg bg-transparent w-100" style="margin: 0 auto;"
                *ngFor='let user of userappointment'>
                <div class="box-body bg-white " style="background-color: #f5f7fa;">
                    <div class="container-fluid   p-2">
                        <div class="row w-100 m-2 d-flex  border-bottom justify-content-between">
                            <div class="col-md-6  p-2  flex-column">
                                <div class="border-bottom border-dark d-flex justify-content-between ">
                                    <div>
                                        <h1 style="color: #0359ae; cursor: pointer;" (click)="openClientDetails(user)">
                                            <strong>{{fullName}}</strong> </h1>
                                    </div>

                                    <div class=" p-2 ">

                                        <label class=" d-flex justify-content-center ">

                                        </label>
                                    </div>

                                </div>

                                <label class="det d-flex justify-content-between my-2 p-1">
                                    <h6 class="d-flex"><strong><i class="fa fa-building mx-1"></i>Branch</strong></h6>
                                    <h6><span class="float-right" style="color: #001f3fb7;">{{user.branch}}<br></span>
                                    </h6>
                                </label>

                                <label class="det d-flex justify-content-between my-2 p-1"
                                    *ngIf="user.describesYou!='Homeowner'">
                                    <h6 class="d-flex"><strong><i class="fas fa-store-alt mx-1"></i>Company
                                            Name</strong></h6>
                                    <h6><span class="float-right"
                                            style="color: #001f3fb7;">{{user.companyName}}<br></span></h6>
                                </label>

                                <label class="det d-flex justify-content-between my-2 p-1">
                                    <h6 class="d-flex"><strong><i class="fa fa-envelope mx-1"></i>Email</strong></h6>
                                    <h6><span class="float-right" style="color: #001f3fb7;">{{user.email}}<br></span>
                                    </h6>
                                </label>

                                <label class="det d-flex justify-content-between my-2 p-1">
                                    <h6 class="d-flex"><strong><i class="fa fa-phone mx-1"></i>Phone</strong></h6>
                                    <h6><span class="float-right" style="color: #001f3fb7;">
                                            {{user.phoneNumber}}<br></span></h6>
                                </label>

                                <label class="det d-flex justify-content-between my-2 p-1">
                                    <h6 class="d-flex"><strong><i class="fa fa-users mx-1"></i>Age Group</strong></h6>
                                    <h6><span class="float-right" style="color: #001f3fb7;">{{user.ageGroup}}<br></span>
                                    </h6>
                                </label>

                                <label class="det d-flex justify-content-between my-2 p-1">
                                    <h6 class="d-flex"><strong><i
                                                class="fas fa-people-arrows mx-1"></i>Reffered</strong></h6>
                                    <h6><span class="float-right"
                                            style="color: #001f3fb7;">{{user.heardAboutUs}}<br></span></h6>
                                </label>

                                <label class="det d-flex justify-content-between my-2 p-1">
                                    <h6 class="d-flex"><strong><i class="fa fa-id-badge mx-1"></i>Description</strong>
                                    </h6>
                                    <h6><span class="float-right"
                                            style="color: #001f3fb7;">{{user.describesYou}}<br></span></h6>
                                </label>
                                <label class="det d-flex justify-content-between my-2 p-1">
                                    <h6 class="d-flex"><strong><i
                                                class="fas fa-user-friends mx-1"></i>Clientele</strong></h6>
                                    <h6><span class="float-right"
                                            style="color: #001f3fb7;">{{user.clientele}}<br></span></h6>
                                </label>
                                <label class="det d-flex justify-content-between my-2 p-1">
                                    <h6 class="d-flex"><strong><i class="fas fa-street-view mx-1"></i>Purpose of
                                            visit</strong></h6>
                                    <h6><span class="float-right"
                                            style="color: #001f3fb7;">{{user.lookingFor}}<br></span></h6>
                                </label>

                                <label class="det d-flex justify-content-between my-2 p-1">
                                    <h6 class="d-flex"><strong><i class="fas fa-calendar-check mx-1"></i>Date
                                            Submitted</strong></h6>
                                    <h6><span class="float-right" style="color: #001f3fb7;">{{user.dateSubmitted |
                                            date:'yyyy-M-d h:mm a'}}<br></span></h6>
                                </label>


                                <label class="det d-flex justify-content-between my-2 p-1">
                                    <h6 class="d-flex"><strong><i class="fa fa-tag mx-1"></i>Tag</strong></h6>
                                    <h6><span class="float-right" style="color: #001f3fb7;">{{user.tag}}<br></span></h6>
                                </label>

                                <label class="det d-flex justify-content-between my-2 p-1">
                                    <h6 class="d-flex"><strong><i class="fa fa-building mx-1"></i>Link</strong></h6>
                                    <h6><span class="float-right" style="color: #001f3fb7;">{{user.link}}<br></span>
                                    </h6>
                                </label>

                                <label class="det d-flex justify-content-between my-2 p-1">
                                    <h6 class="d-flex"><strong><i class="fas fa-link mx-1"></i>Person Count</strong>
                                    </h6>
                                    <h6><span class="float-right"
                                            style="color: #001f3fb7;">{{user.personCount}}<br></span></h6>
                                </label>


                                <div class="col-md-12  mt-3 border rounded p-3" style="background-color: #f5f7fa;"
                                    [style.color]="user.salesRepColor">
                                    <label>
                                        <strong translate>Sales Representative</strong>
                                    </label>
                                    <h5 class="float-right">{{user.salesRep}} </h5>
                                </div>


                            </div>

                            <div class="col-md-6  p-2 flex-column ">

                                <div class="status-badge status-pending" *ngIf="user.status=='Pending'">
                                    STATUS: {{user.status}}
                                </div>
                                <div class="status-badge status-cancelled" *ngIf="user.status=='Cancelled'">
                                    STATUS: {{user.status}}
                                </div>
                                <div class="status-badge status-progress" *ngIf="user.status=='In Progress'">
                                    STATUS: {{user.status}}
                                </div>
                                <div class="status-badge status-completed" *ngIf="user.status=='Completed'">
                                    STATUS: {{user.status}}
                                </div>





                                <div class="timeline">
                                    <div class="timeline-item timeline-in">
                                        <div class="timeline-label">Time In</div>
                                        <i class="fas fa-calendar-alt timeline-icon"></i>
                                        <div>{{user.timeIn| date:'yyyy-M-d h:mm a'}}</div>
                                    </div>

                                    <div class="timeline-item timeline-out">
                                        <div class="timeline-label">Time Out</div>
                                        <i class="far fa-calendar-alt timeline-icon"></i>
                                        <div>{{user.timeOut| date:'yyyy-M-d h:mm a'}}</div>
                                    </div>
                                </div>


                                <div class="p-1  mb-1   " style=" width: 100%; height: 100%;">

                                    <div class=" border-top border-dark" style="align-content:center;">
                                        <div class="d-flex justify-content-between mt-1  ">
                                            <h5 class="d-flex" style="color: #0359ae;"><strong>Notes</strong></h5><a
                                                style="font-size:small;" *ngIf="isAdmin() || isSystemAdmin() "
                                                class=" rounded p-1  float-right"
                                                (click)="openNotesModal(notesModal)"><i class="fa fa-plus  pt-1"></i>
                                            </a>
                                        </div>
                                        <div class="mt-1  p-2"
                                            style="border-style: solid; border-width: 1px;; border-color: #001f3f; overflow-y: auto; height: 250px;">
                                            <span class="notesline w-100 text-left text-break "
                                                style="white-space: pre-line; "> {{user.notes}}<br></span>
                                        </div>
                                    </div>
                                    <div class="w-100 d-flex justify-content-around flex-column">

                                        <button (click)='deleteAppointment(userappointment[0])'
                                            *ngIf="isSystemAdmin() || isAdmin() || isReceptionist()"
                                            class="btn p-1 m-2 float-right bg-danger text-white"
                                            style="line-height: 5;font-size: small;"><i
                                                class="fa fa-trash fa-2x mx-2 text-white"></i>Delete
                                            Appointment</button>

                                        <button (click)="completeAppointment(user)" *ngIf="user.status!='Completed'"
                                            class=" btn p-1 m-2 float-right bg-success text-white"
                                            style="line-height: 5; font-size: small;" translate><i
                                                class="fa fa-check fa-2x mx-2"></i>Mark As Completed</button>

                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>







            </div>
        </div>
    </div>


</section>
<!------------------------------------------------------------------------------------->
<!------------------------------------------------------------------------------------->





<!--
<section class="container-fluid p-0 w-100 ">
    <div class="row w-100 m-0 ">    
  
        <div class="col-xs-12 w-100">
            
            <div class="box box-primary  border-top  shadow-lg bg-transparent w-100">
               
                <div class="box-header m-2 border-bottom w-100 row d-flex justify-content-between" *ngFor='let user of userappointment'>
                    <h3 class="p-2" style="cursor: pointer;" (click)="openClientDetails(user)"><strong>{{fullName}}</strong></h3>

                    <div class="row d-flex justify-content-between mr-2">

        <div class="d-flex text-white ">
         
            <a class="fa fa-trash fa-3x mx-3 text-danger" style="cursor: pointer;" (click)='deleteAppointment(userappointment[0])' *ngIf="isSystemAdmin() || isAdmin() || isReceptionist()"></a>
        </div>
                    <h4 class="btn  btn-sm text-success p-2 rounded border border-success " (click)="completeAppointment(user)" *ngIf="user.status!='Completed'"  translate ><i class="fa fa-check"></i> Mark as Completed</h4>
                    
                   <h5 class=" bg-warning text-white mx-3 p-2 rounded" *ngIf="user.status=='Pending'">{{user.status}}</h5>
                   <h5 class=" bg-primary text-white mx-3 p-2 rounded" *ngIf="user.status=='In Progress'">{{user.status}}</h5>
                   <h5 class=" bg-success text-white mx-3 p-2 rounded" *ngIf="user.status=='Completed'">{{user.status}}</h5>
                   <h5 class=" bg-danger text-white mx-3 p-2 rounded" *ngIf="user.status=='Cancelled'">{{user.status}}</h5>
               
                
            </div>
                </div>




               


                <div class="box-body  " style="background-color: #f5f7fa;">
                    <div class="container-fluid   p-2">



                        <div class=" row flex-row justify-content-around  m-1"  >
                            <div class="flex-column col-sm-4 box box-primary  border-top border-primary shadow-sm bg-white   p-3"
                                style="max-width:100%; min-width: 32%; font-family:Trebuchet MS; " *ngFor='let user of userappointment'>
                                <label *ngIf="user.describesYou!='Homeowner'"  class="d-flex justify-content-between" >
                                    <h6 class="d-flex"><strong translate>Email</strong></h6>
                                    <h6><span class="float-right">{{user.email}}<br></span>
                                    </h6>
                                </label>

                                <label class="d-flex justify-content-between" *ngFor='let user of userappointment'>
                                    <h6 class="d-flex"><strong translate>Phone</strong></h6>
                                    <h6><span
                                            class="d-flex float-right">{{user.phoneNumber}}<br></span></h6>
                                </label>

                                <label class="d-flex justify-content-between" *ngFor='let user of userappointment'>
                                    <h6 class="d-flex"><strong translate>Branch</strong></h6>
                                    <h6><span
                                            class="d-flex float-right">{{user.branch}}<br></span></h6>
                                </label>

                                <label class="d-flex justify-content-between" *ngFor='let user of userappointment'>
                                    <h6 class="d-flex"><strong translate>Age Group</strong></h6>
                                    <h6><span class="float-right">{{user.ageGroup}}<br></span>
                                    </h6>
                                </label>

                     

                            </div>

                            <div class="flex-column col-sm-4 box box-primary border-top border-primary shadow-sm bg-white p-3 " 
                                style="max-width:100%; min-width: 25%; font-family:Trebuchet MS; " *ngFor='let user of userappointment'>
                                <label *ngIf="user.describesYou!='Homeowner' "  class="d-flex justify-content-between" >
                                    <h6 class="d-flex" ><strong translate>Company Name</strong></h6>
                                    <h6><span class="float-right">{{user.companyName}}<br></span>
                                    </h6>
                                </label>

                                <label class="d-flex justify-content-between" *ngFor='let user of userappointment'>
                                    <h6 class="d-flex"><strong translate>Description</strong></h6>
                                    <h6><span
                                            class="d-flex float-right">{{user.describesYou}}<br></span></h6>
                                </label>

                                <label class="d-flex justify-content-between" *ngFor='let user of userappointment'>
                                    <h6 class="d-flex"><strong translate>Clientele</strong></h6>
                                    <h6><span
                                            class="d-flex float-right">{{user.clientele}}<br></span></h6>
                                </label>

                                <label class="d-flex justify-content-between" *ngFor='let user of userappointment'>
                                    <h6 class="d-flex"><strong translate> Purpose of visit</strong></h6>
                                    <h6><span class="float-right">{{user.lookingFor}}<br></span>
                                    </h6>
                                </label>

                            </div>

                            <div class="d-flex flex-column justify-content-between col-sm-4 box box-primary border-top  border-primary shadow-sm bg-white   p-3 "
                                style="max-width:100%; min-width: 32%; font-family:Trebuchet MS;">
                                <label class="d-flex justify-content-between" *ngFor='let user of userappointment'>
                                    <h6 class="d-flex"><strong translate>Time In</strong></h6>
                                    <h6><span
                                            class="d-flex float-right">{{user.timeIn |  date:'yyyy-M-d h:mm a'}}<br></span></h6>
                                </label>

                                <label class="d-flex justify-content-between" *ngFor='let user of userappointment'>
                                    <h6 class="d-flex"><strong translate>Time Out</strong></h6>
                                    <h6><span
                                            class="d-flex float-right">{{user.timeOut |  date:'yyyy-M-d h:mm a'}}<br></span></h6>
                                </label>

                                <label class="d-flex justify-content-between" *ngFor='let user of userappointment'>
                                    <h6 class="d-flex"><strong translate>Date Submitted</strong></h6>
                                    <h6><span class="float-right">{{user.dateSubmitted | date:'yyyy-M-d h:mm a'}}<br></span>
                                    </h6>
                                </label>

                                <label class="d-flex justify-content-between" *ngFor='let user of userappointment'>
                                    <h6 class="d-flex"><strong translate>Created By</strong></h6>
                                    <h6><span class="float-right">{{user.createdBy}}<br></span>
                                    </h6>
                                </label>
                            </div>

                        </div>





                        <div class="row d-flex justify-content-between w-100 m-1">
                            <div class="flex-column col-sm-4 box box-primary  border-top border-primary shadow-sm bg-white   p-3"
                            style="max-width:100%; min-width: 32%; font-family:Trebuchet MS; " *ngFor='let user of userappointment'>
                            <label class="text-bold">
                                <h3><strong translate>Sales Representative</strong></h3>
                            </label><br>
                            <h5 class="float-right">{{user.salesRep}}          </h5>
                              

                        </div>

                         


                            
                            <div class="col-sm-4 d-flex flex-column justify-content-between  box box-primary border-top border-primary shadow-sm bg-white p-3 "*ngFor='let user of userappointment' 
                                style="max-width:100%; min-width: 33%; ">
                              
                                <label class="d-flex justify-content-between" *ngFor='let user of userappointment'>
                                    <h6 class="d-flex"><strong translate>Request Type</strong></h6>
                                    <h6><span
                                            class="d-flex float-right">{{user.requestType}}<br></span></h6>
                                </label>

                                <label class="d-flex justify-content-between" *ngFor='let user of userappointment'>
                                    <h6 class="d-flex"><strong translate>COVID-19 Cleared</strong></h6>
                                    <h6><span
                                            class="d-flex float-right">{{user.covid}}<br></span></h6>
                                </label>

                                <label class="d-flex justify-content-between" *ngFor='let user of userappointment'>
                                    <h6 class="d-flex"><strong translate>Person Count</strong></h6>
                                    <h6><span class="float-right">{{user.personCount}}<br></span>
                                    </h6>
                                </label>
                            </div>



                            <div class="col-sm-4 d-flex flex-column justify-content-between  box box-primary border-top border-primary shadow-sm bg-white p-3 "*ngFor='let user of userappointment' 
                            style="max-width:100%; min-width: 33%; ">
                          
                            <label class="d-flex justify-content-between" *ngFor='let user of userappointment'>
                               
                                    <h6 class="d-flex"><strong translate>Link</strong></h6>
                                <h6><span
                                        class="d-flex float-right">{{user.webLink}}<br></span></h6>
                                
                            </label>

                            <label class="d-flex justify-content-between" *ngFor='let user of userappointment'>
                                
                                <h6 class="d-flex"><strong translate>Tag</strong></h6>
                                <h6><span
                                        class="d-flex float-right">{{user.tag}}<br></span></h6>
                                    
                            </label>

                            <label class=" " *ngFor='let user of userappointment'>
                               <div class="d-flex justify-content-between mt-2"> <h6 class="d-flex"><strong translate>Notes</strong></h6><a style="font-size:small;" class="bg-dark rounded p-1 text-white float-right" (click)=openNotesModal(notesModal)
                                    translate><i class="fa fa-plus"></i > ADD</a></div>
                                <h6><span id="notesline"
                                        class="d-flex float-left">{{user.notes}}<br></span></h6>

                            </label>

                            
                        </div>


                        </div>



                    </div>
                






    			
       

                    </div>
            





            </div>
        </div>
    </div>

</section>-->





<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success DeleteModal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openSuccessDeleteModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessDeleteModal">Open
    Modal</button>
<!-- Modal -->
<div id="SuccessDeleteModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
            </div>
            <div class="modal-body " style="background: black;">
                <div class="row p-5 ">
                    <div class="col-sm-12 w-100">
                        <div class="d-flex flex-column justify-content-between  row w-100 m-0">


                            <img class="px-3"
                                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                src="./assets/logo2020w.png" />

                            <div class="w-100 text-center">
                                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU
                                </h3>
                            </div>

                            <div class="border  bg-white "></div>
                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Appointment
                                    has been deleted.</h4>
                            </div>




                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default text-center" (click)="backClicked()"
                    data-dismiss="modal">Close</button>
            </div>
        </div>

    </div>
</div>


<!------------------------------------------------------------------------------------------------------------------------------------------
                                           Error Modal
                                        ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal">Open Modal</button>
<!-- Modal -->
<div id="ErrorModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <h4 class="modal-title text-danger" translate>ERROR</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body text-danger">
                <p>{{error}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="backClicked()" data-dismiss="modal"
                    translate>Close</button>
            </div>
        </div>

    </div>


</div>


<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Complete Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openSuccessCompleteModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessCompleteModal">Open
    Modal</button>
<!-- Modal -->
<div id="SuccessCompleteModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
            </div>
            <div class="modal-body " style="background: black;">
                <div class="row p-5 ">
                    <div class="col-sm-12 w-100">
                        <div class="d-flex flex-column justify-content-between  row w-100 m-0">


                            <img class="px-3"
                                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                src="./assets/logo2020w.png" />

                            <div class="w-100 text-center">
                                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU
                                </h3>
                            </div>

                            <div class="border  bg-white "></div>
                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Appointment
                                    has been marked as complete.</h4>
                            </div>




                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default text-center" (click)='backClicked()' data-dismiss="modal"
                    translate>Close</button>
            </div>
        </div>

    </div>
</div>
<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Email Sent Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openSuccessEmailSentModalButton" [hidden]="true" data-toggle="modal"
    data-target="#SuccessEmailSentModal">Open Modal</button>
<!-- Modal -->
<div id="SuccessEmailSentModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
            </div>
            <div class="modal-body " style="background: black;">
                <div class="row p-5 ">
                    <div class="col-sm-12 w-100">
                        <div class="d-flex flex-column justify-content-between  row w-100 m-0">


                            <img class="px-3"
                                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                src="./assets/logo2020w.png" />

                            <div class="w-100 text-center">
                                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU
                                </h3>
                            </div>

                            <div class="border  bg-white "></div>
                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Email has
                                    been sent.</h4>
                            </div>




                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default text-center" (click)='backClicked()' data-dismiss="modal"
                    translate>Close</button>
            </div>
        </div>

    </div>
</div>




<!----------Notes Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<ng-template #notesModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="statuLabel" translate>Notes</h5>
        <button type="button" class="close" style=" outline: none;" (click)="modal.dismiss()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <form [formGroup]="notesForm">
            <div class="form-group row">
                <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder"
                    formControlName="modalMsg" id="modalMsg">

                <div class="w-100 mx-2">
                    <textarea type="textarea" class="form-control mt-2 w-100" formControlName='notes'></textarea>

                </div>

            </div>





            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
                <button type="submit" class="btn btn-primary" (click)=saveNotes(); translate>Save</button>
            </div>
        </form>
    </div>
</ng-template>



<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessModal">Open Modal</button>
<!-- Modal -->
<div id="SuccessModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
            </div>
            <div class="modal-body " style="background: black;">
                <div class="row p-5 ">
                    <div class="col-sm-12 w-100">
                        <div class="d-flex flex-column justify-content-between  row w-100 m-0">


                            <img class="px-3"
                                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                src="./assets/logo2020w.png" />

                            <div class="w-100 text-center">
                                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU
                                </h3>
                            </div>

                            <div class="border  bg-white "></div>
                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Appointment
                                    has been saved.</h4>
                            </div>



                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default text-center" data-dismiss="modal" translate>Close</button>
            </div>
        </div>

    </div>
</div>